<small #errorMessageElement class="sos-error"><ng-content></ng-content></small>